import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const employeeContractApi = createApi({
  reducerPath: 'employeeContractApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/employee_contracts' }),
  endpoints: (builder) => ({
    getEmployeeContracts: builder.query({
      query: () => ({ url: '' }),
      providesTags: ['EmployeeContractAttachment']
    }),
    createRequestContractChange: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${id}/contract_changes`,
        method: 'POST',
        body: { request_contract_change: body }
      })
    }),
    createRequestContractTermination: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${id}/contract_termination`,
        method: 'POST',
        body: { request_contract_termination: body }
      })
    }),
    updateEmployeeContract: builder.mutation({
      query: ({ id, ...data }) => ({
        url: id ? `/${id}` : '',
        method: 'PATCH',
        body: { employee_contract: data }
      }),
      invalidatesTags: ['EmployeeContractAttachment']
    })
  })
})

const {
  useUpdateEmployeeContractMutation,
  useGetEmployeeContractsQuery,
  useCreateRequestContractChangeMutation,
  useCreateRequestContractTerminationMutation
} = employeeContractApi

export {
  useUpdateEmployeeContractMutation,
  useGetEmployeeContractsQuery,
  useCreateRequestContractChangeMutation,
  useCreateRequestContractTerminationMutation,
  employeeContractApi
}
